import { Component, ViewContainerRef } from '@angular/core';
import { SystemSetting } from '../../models/system-setting/system-setting.model';
import { SystemSettingService } from '../../services/system-settings/system-setting.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { Router } from '@angular/router';
@Component({
    selector: 'app-create-setting',
    templateUrl: './create-setting.component.html',
    styleUrls: ['./create-setting.component.scss']
})
/** Create-setting component*/
export class CreateSettingComponent {
  /** Create-setting ctor */
  systemSetting = new SystemSetting();
  fileToUpload: File;
  fd = new FormData();
  selectedWebsiteLogo: string;
  selectedFavIcon: string;
  constructor(private readonly systemSettingService: SystemSettingService,
    private readonly toastr: ToastsManager,
    vcr: ViewContainerRef, private readonly router: Router, private readonly rolePermissionService: RolePermissionService) {
    this.systemSetting.metaTagDescription = "";
    this.systemSetting.metaTagKeywords = "";
    this.rolePermissionService.GetRolePermissions("systemsetting").subscribe(
      data => {
        if (data != null) {
          var list = data.filter(function (element) {
            return (element.action == "list");
          });
          if (list.length > 0) {
            this.toastr.setRootViewContainerRef(vcr);
            this.GetSystemSettingFirstOrDefault();
          }
          else {
            this.router.navigate(["/"]);
          }
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )
  }

  GetSystemSettingFirstOrDefault() {
    this.systemSettingService.GetSystemSettingFirstOrDefault().subscribe(
      data => {
        this.systemSetting = data;
        if (this.systemSetting.defaultCurrency == null) {
          this.systemSetting.defaultCurrency = "";
        }
        if (this.systemSetting.currencySymbol == null) {
          this.systemSetting.currencySymbol = "";
        }
        if (this.systemSetting.defaultTimezone == null) {
          this.systemSetting.defaultTimezone = "";
        }
        if (this.systemSetting.dateFormat == null) {
          this.systemSetting.dateFormat = "";
        }
        if (this.systemSetting.timeFormat == null) {
          this.systemSetting.timeFormat = "";
        }
      }
    )
  }
  uploadSiteLogo(file: FileList) {
    this.fileToUpload = file.item(0);
    this.fd.append("WebsiteLogo", this.fileToUpload);
    ////Show image preview
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.selectedWebsiteLogo = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
  }
  uploadFavIcon(file: FileList) {
    this.fileToUpload = file.item(0);
    this.fd.append("WebsiteFavIcon", this.fileToUpload);
    ////Show image preview
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.selectedFavIcon = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
  }

  onSubmit() {
    if (this.systemSetting.id != null && this.systemSetting.id != "") {
      this.systemSettingService.UpdateSystemSetting(this.systemSetting);
      this.systemSettingService.SaveWebsiteLogo(this.fd);
      //this.systemSettingService.SaveFavIcon(this.fd);
      this.toastr.success('System Settings has been Updated.', 'Success');
    } else {
      this.systemSettingService.AddSystemSetting(this.systemSetting).subscribe(result => {
        this.toastr.success('System Settings has been Saved.', 'Success');
        this.systemSettingService.SaveWebsiteLogo(this.fd);
        //this.systemSettingService.SaveFavIcon(this.fd);
        this.GetSystemSettingFirstOrDefault();
      });
    }
    
  }
  KeyPress(event: any) {
  var regex = new RegExp("^[0-9-!@#$%*?+]");
  var key = String.fromCharCode(event.charCode ? event.which : event.charCode);
  if (!regex.test(key)) {
    event.preventDefault();
    event
    return false;
  }
}       
  
}



// WEBPACK FOOTER //
// ./src/app/system-setting-component/create-setting/create-setting.component.ts